import { render, staticRenderFns } from "./GridCompany.vue?vue&type=template&id=28830af5&"
import script from "./GridCompany.vue?vue&type=script&lang=js&"
export * from "./GridCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports